import createReducer from '../lib/createReducer';
import * as types from '../constants/ActionTypes';

const initialState = {
  door: {},
  fields: {},
  fieldOrder: []
};

export default createReducer(initialState, {
  [types.UPDATE_FIELD_VALUE](state, { field }) {
    return state.setIn(['fields', field.name, 'value'], field.value);
  },
  
  [types.UPDATE_CUSTOM_FIELD_VALUE](state, { field }) {
    return state.setIn(['fields', field.name, 'custom_value'], field.value);
  },
  
  [types.SET_NEW_STATE](state, { newState }) {
    return newState;
  }
});
